import FolderIcon from "@/icons/FolderIcon";
import ImageIcon from "@/icons/ImageIcon";
import FilmIcon from "@/icons/FilmIcon";
import FileIcon from "@/icons/FileIcon";
import ZipIcon from "@/icons/ZipIcon";
import FileTextIcon from "@/icons/FileTextIcon";
import FilePdfIcon from "@/icons/FilePdfIcon";
import FileExcelIcon from "@/icons/FileExcelIcon";

// Форматирование даты вида YYYY-MM-DD в DD.MM.YYYY
export const formateDate = (date) => {
  if (!date) return null;

  const [year, month, day] = date.split("-");

  return `${day}.${month}.${year}`;
};

// Форматирование даты из формата ISO в строку (10.03.2025)
export const formateISODateToStr = (isoDate) => {
  if (!isoDate) return null;

  const date = new Date(isoDate);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}.${month}.${year}`;
};

// Форматирование даты из формата ISO в строку (10.03.25)
export const formateISODateToStrMin = (isoDate) => {
  if (!isoDate) return null;

  const date = new Date(isoDate);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = String(date.getUTCFullYear()).slice(-2);

  return `${day}.${month}.${year}`;
};

// Форматирование даты из формата ISO в строку с временем (01.04.2025, 17:07)
export const formateISODateToMoment = (isoDate) => {
  if (!isoDate) return null;

  const date = new Date(isoDate);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return date.toLocaleString("ru-RU", {
    timeZone: userTimeZone,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Форматирование даты из формата ISO в строку с временем (01 октября 2025, 17:07)
export const formateISODateToText = (isoDate) => {
  if (!isoDate) return null;

  const date = new Date(isoDate);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return date.toLocaleString("ru-RU", {
    timeZone: userTimeZone,
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

// Форматирование даты из ISO в дата | время  (05.03.2025 | 15:33:14)
export const formateISODateToDateTime = (isoDate) => {
  if (!isoDate) return null;

  const date = new Date(isoDate);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return `${date.toLocaleString("ru-RU", {
    timeZone: userTimeZone,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })} | ${date.toLocaleString("ru-RU", {
    timeZone: userTimeZone,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })}`;
};

export const formatISODateToCustomStr = (isoDate) => {
  if (!isoDate) return null;

  const date = new Date(isoDate);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const options = {
    timeZone: userTimeZone,
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };

  const formattedDate = date.toLocaleString("ru-RU", options);

  // Преобразуем формат даты
  const [day, month, time] = formattedDate.split(/[\s,]+/);

  return `${day} ${month}, ${time}`;
};

// Форматирование даты из строки в формате dd.mm.yyyy в формат ISO
export const formateStrToISODate = (str) => {
  if (!str || str === "__.__.____") return null;

  const [day, month, year] = str.split(".");
  return new Date(Date.UTC(year, month - 1, day)).toISOString();
};

export const cleanParams = (params) => {
  if (!params) return {};
  return Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v !== ""),
  );
};

/**
 * Преобразует объект фильтров в query string с поддержкой массивов (key[])
 * @param {Object} params - Объект фильтров
 * @returns {string} - query string
 */
export const buildQueryParams = (params) => {
  const urlSearch = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => urlSearch.append(`${key}[]`, v));
    } else {
      urlSearch.append(key, value);
    }
  });
  return urlSearch.toString();
};

export const calcDeadline = (date) => {
  const today = new Date();
  const inputDate = new Date(date);

  // Сброс времени для корректного сравнения только дат
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  if (inputDate > today) {
    return "success";
  } else if (
    inputDate.getTime() === today.getTime() ||
    inputDate.getTime() === today.getTime() + 86400000
  ) {
    return "warning";
  } else {
    return "error";
  }
};

export const generateRandomKey = () => {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export const getDaysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

export const getFirstDay = (month, year) => {
  return new Date(year, month - 1, 1);
};

// Полное имя
export const getFullName = (lastname, firstname, patronymic) => {
  return [lastname, firstname, patronymic].filter(Boolean).join(" ");
};

// Фамилия и инициалы
export const getName = (lastname, firstname, patronymic) => {
  return `${lastname} ${[firstname, patronymic]
    .filter(Boolean)
    .map((str) => `${str[0]}.`)
    .join(" ")}`;
};

// Преобразует переносы строк в теги <br />
export const replaceNewLine = (text) => {
  if (!text) return "";
  return text.replace(/\n/g, "<br />");
};

// Возвращает число с текстом в нужном падеже
// Пример: getPluralizedWord(5, ['день', 'дня', 'дней']) => '5 дней'
export const getPluralizedWord = (number, words) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return words[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
};

// Убирает эмоджи из строки
export const removeEmoji = (str) => {
  if (!str) return "";

  return str.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]|\uFE0F/g, "").trimStart();
};
export const copyLinkToClipboard = async (currentUrl) => {
  if (
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function"
  ) {
    try {
      await navigator.clipboard.writeText(currentUrl);
      return {
        success: true,
        message: "Ссылка скопирована в буфер обмена",
      };
    } catch {
      return {
        success: false,
        message: "Не удалось скопировать ссылку.",
      };
    }
  } else {
    // Фоллбэк для старых браузеров
    try {
      const input = document.createElement("input");
      input.value = currentUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      return {
        success: true,
        message: "Ссылка скопирована в буфер обмена",
      };
    } catch (e) {
      return {
        success: false,
        message: "Не удалось скопировать ссылку.",
      };
    }
  }
};

// Возвращает иконку для файла или папки в зависимости от типа
export const getIconByType = (
  type,
  extension,
  element_type,
  fontSize = "22px",
  color = "var(--color-secondary)",
) => {
  if (element_type === "folder")
    return <FolderIcon style={{ color, fontSize }} />;

  switch (type) {
    case "image":
      return <ImageIcon style={{ color, fontSize }} />;
    case "video":
      return <FilmIcon style={{ color, fontSize }} />;

    case "application":
      switch (extension) {
        case "zip":
          return <ZipIcon style={{ color, fontSize }} />;
        case "docx":
          return <FileTextIcon style={{ color, fontSize }} />;
        case "pdf":
          return <FilePdfIcon style={{ color, fontSize }} />;
        case "xlsx":
          return <FileExcelIcon style={{ color, fontSize }} />;
        default:
          return <FileIcon style={{ color, fontSize }} />;
      }

    default:
      return <FileIcon style={{ color, fontSize }} />;
  }
};

export const formatMilliseconds = (ms) => {
  const hours = ms / 1000 / 60 / 60;

  if (hours > 23) {
    const days = Math.floor(hours / 24);
    return `${days} ${getPluralizedWord(days, ["день", "дня", "дней"])}`;
  } else {
    return `${Math.floor(hours)} ${getPluralizedWord(Math.floor(hours), [
      "час",
      "часа",
      "часов",
    ])}`;
  }
};
